import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useEffect, useContext } from "react";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import { connection } from "./apiConnection.ts";
import Cookies from "js-cookie";

export default function WithPageTitle({ children }) {
  const auth = useContext(AuthenticationContext);
  const { pathname: currentPath } = useLocation();

  useEffect(() => {
    let usertoken = Cookies.get("token");

    let date = new Date();
    connection("api/Insert_Visits", {
      uid: auth.userInfo.id || 0,
      mtm: Math.floor(date.getTime() / 1000),
      route: currentPath,
      user_token: usertoken,
    });
  });

  return (
    <>
      <Helmet>
        <title> سبدی </title>
        <description> Service base shop website. </description>
      </Helmet>
      {children}
    </>
  );
}
